import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import SearchIcon from '@atlaskit/icon/core/search';
import { Inline } from '@atlaskit/primitives';
import { usePublish } from '@atlaskit/rovo-triggers';
import { N500 } from '@atlaskit/theme/colors';
import { FollowUpButton } from '@atlassian/conversation-assistant-ui-components';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { AiBrand } from '../../constants';
import { useAIAnswerContext } from '../ai-answer-context';
import { onFollowUpSuggestionClick } from '../analytics';
import { AIAnswerFollowUpPill, AIAnswerFollowUpPillText } from './styled';
export var FollowUpSuggestionFooter = function FollowUpSuggestionFooter() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    setQuery = _useAIAnswerContext.setQuery,
    updateContextCache = _useAIAnswerContext.updateContextCache,
    onClose = _useAIAnswerContext.onClose,
    closeParentDialog = _useAIAnswerContext.closeParentDialog,
    brand = _useAIAnswerContext.brand,
    callbacks = _useAIAnswerContext.callbacks;
  var followUps = commonAttributes.followUps,
    query = commonAttributes.query,
    answerString = commonAttributes.answerString,
    searchSessionId = commonAttributes.searchSessionId;
  var publish = usePublish('ai-mate');
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var visibleFollowUps = followUps.slice(0, 2);
  var onPillClick = useCallback(function (followUp) {
    var _callbacks$onFollowUp;
    if (brand === AiBrand.ROVO) {
      publish({
        type: 'chat-new',
        source: 'sain',
        data: {
          name: followUp.substring(0, 30),
          dialogues: [{
            human_message: {
              content: query
            },
            agent_message: {
              content: answerString
            }
          }],
          prompt: followUp,
          sourceId: searchSessionId
        }
      });
    } else {
      setQuery(followUp);
      updateContextCache({
        fromFollowUp: true
      });
    }
    fireAnalyticsEvent(onFollowUpSuggestionClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      followUpString: followUp
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.FOLLOWUP_CLICKED,
      commonAttributes: commonAttributes
    });
    onClose === null || onClose === void 0 || onClose();
    closeParentDialog === null || closeParentDialog === void 0 || closeParentDialog();
    callbacks === null || callbacks === void 0 || (_callbacks$onFollowUp = callbacks.onFollowUpSuggestionClick) === null || _callbacks$onFollowUp === void 0 || _callbacks$onFollowUp.call(callbacks);
  }, [fireSAINUsageEvent, brand, fireAnalyticsEvent, commonAttributes, onClose, closeParentDialog, callbacks, publish, query, answerString, searchSessionId, setQuery, updateContextCache]);
  return followUps.length > 0 ? visibleFollowUps.map(function (followUp, index) {
    if (brand === AiBrand.ROVO) {
      return /*#__PURE__*/React.createElement(Inline, {
        space: "space.050",
        alignBlock: "center",
        key: followUp
      }, /*#__PURE__*/React.createElement(FollowUpButton, {
        onClick: function onClick() {
          return onPillClick(followUp);
        },
        followUpText: followUp,
        followUpIndex: index,
        followUpType: "UNAVAILABLE",
        experienceId: "sain"
      }));
    }
    return /*#__PURE__*/React.createElement(Inline, {
      space: "space.050",
      alignBlock: "center",
      key: followUp
    }, /*#__PURE__*/React.createElement(AIAnswerFollowUpPill, {
      onClick: function onClick() {
        return onPillClick(followUp);
      }
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      label: "",
      LEGACY_size: "small",
      color: "var(--ds-icon, ".concat(N500, ")")
    }), /*#__PURE__*/React.createElement(AIAnswerFollowUpPillText, null, followUp)));
  }) : null;
};